import {_MICRONUTRIENTS} from '../../components/micronutrient-list/micronutrient-list.component';

export class DDR {
  private micronutrients = _MICRONUTRIENTS;
  constructor(values: number[]) {
    for (let i = 0; i < values.length; i++) {
      this.micronutrients[i].ddr = values[i];
    }
  }

  getMicronutrients(): any[] {
    return this.micronutrients;
  }

  getMicronutrientsWithValues(): any[] {
    return this.micronutrients;
  }

  getIndexedMicronutrients(): any {
    return this.micronutrients.reduce((prev, current) => {
      return {
        ...prev,
        [current._id]: current
      };
    }, {});
  }

  concatDDRValues(data: any[]): any[] {
    const indexed = this.getIndexedMicronutrients();
    const dataIndexed = data.reduce((prev, current) => {
      return {
        ...prev,
        [current._id]: current
      };
    }, {});
    try {
      for (const prop of Object.keys(indexed)) {
        dataIndexed[prop].ddr = indexed[prop].ddr;
        // tslint:disable-next-line:max-line-length
        dataIndexed[prop].difference = dataIndexed[prop]?.value > indexed[prop].ddr ? (dataIndexed[prop]?.value - indexed[prop].ddr).toFixed(2) : dataIndexed[prop]?.value < indexed[prop].ddr ? (indexed[prop]?.ddr - dataIndexed[prop].value).toFixed(2) : '';
      }
    } catch (e) {
      console.log(e);
    }
    return Object.values(dataIndexed);
  }
}
